module.exports = __webpack_public_path__ + "static/sub-services-9-2937645e60a20b5db616de595121164d.jpg";